import { render } from "./customSwitchSlider.vue?vue&type=template&id=b2a80070"
import script from "./customSwitchSlider.vue?vue&type=script&lang=js"
export * from "./customSwitchSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__